import { render, staticRenderFns } from "./PasoCuatro.vue?vue&type=template&id=caf72822"
import script from "./PasoCuatro.vue?vue&type=script&lang=js"
export * from "./PasoCuatro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports